document.addEventListener('alpine:init', () => {
  Alpine.data('header', () => ({
    clickCTA(el) {
      // eTracker
      if (window._etracker) {
        _etracker.sendEvent(new et_ClickEvent('HeaderMenuCTAClick'));
      }

      setTimeout(() => {
        window.location.href = el.href;
      }, 250);
    },
  }));
});